import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAccess } from "./AccessProvider";
import AccessRouteState from "./AccessRouteState";

export default function TenantMemberRoute({ children }) {
  const location = useLocation();
  const { user, activeTenant, loading, error } = useAccess();

  if (loading) return <AccessRouteState />;
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!user.emailVerified) {
    return <Navigate to="/access-pending?reason=email-verification" replace />;
  }
  if (error) {
    return (
      <AccessRouteState
        title="Access could not be verified"
        message="Please try signing in again or contact access support."
      />
    );
  }
  if (!activeTenant) return <Navigate to="/access-pending" replace />;
  return children;
}
